import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { LoginTemplate } from 'components/templates/LoginTemplate'
import { theme } from 'styles/theme'
import { MiteneIntlProvider } from './MiteneIntlProvider'

export const LoginProvider = () => (
  <StyledEngineProvider injectFirst={true}>
    <ThemeProvider theme={theme}>
      <MiteneIntlProvider>
        <LoginTemplate />
      </MiteneIntlProvider>
    </ThemeProvider>
  </StyledEngineProvider>
)
